<template>
  <Teleport to="body">
    <Transition name="toast">
      <div v-if="visible" class="global-toast">{{ message }}</div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { visible, message } = useToast()
</script>

<style scoped>
.global-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  z-index: 10000;
  max-width: 80%;
  min-width: 120px;
  text-align: center;
  word-break: break-word;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
}
</style>
